/**
 * 应用全局状态
 */
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import type { User } from '@/types';

interface AppState {
  // 状态
  isInitialized: boolean;
  currentProjectId: string | null;
  user: User | null;

  // 操作
  setInitialized: (value: boolean) => void;
  setCurrentProject: (projectId: string | null) => void;
  setCurrentProjectId: (projectId: string | null) => void;
  setUser: (user: User | null) => void;
  reset: () => void;
}

const initialState = {
  isInitialized: false,
  currentProjectId: null,
  user: null,
};

export const useAppStore = create<AppState>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,

        setInitialized: (value) => set({ isInitialized: value }),
        setCurrentProject: (projectId) => set({ currentProjectId: projectId }),
        setCurrentProjectId: (projectId) => set({ currentProjectId: projectId }),
        setUser: (user) => set({ user }),
        reset: () => set(initialState),
      }),
      {
        name: 'app-store',
        partialize: (state) => ({
          currentProjectId: state.currentProjectId,
        }),
      }
    ),
    { name: 'AppStore' }
  )
);
